import { render, staticRenderFns } from "./SequenceSection.vue?vue&type=template&id=1bad1221&scoped=true"
import script from "./SequenceSection.vue?vue&type=script&lang=js"
export * from "./SequenceSection.vue?vue&type=script&lang=js"
import style0 from "./SequenceSection.vue?vue&type=style&index=0&id=1bad1221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad1221",
  null
  
)

export default component.exports